export { dateFormat, toUTC as DateToUTC, add, isToday } from './date-fns'
export { moneyFormat } from './dinero'
export { toTitleCase } from './capitalize'
export { differenceInHoursAndMinutes } from './date'
export {
  hasActiveMembership,
  hasSuspendedMembership,
  getMembershipStatus,
  hasDelayedMembership
} from './membershipFunction'

export const getCodeToPaste = (text) => {
  if (text && Number.isNaN(text)) return
  const textArray = text.slice(0, 6).split('')

  for (let index = 0; index < 6; index++) {
    !textArray[index] && textArray.push('')
  }
  return textArray
}

const accentMap = {
  á: 'a',
  é: 'e',
  í: 'i',
  ó: 'o',
  ú: 'u',
  Á: 'A',
  É: 'E',
  Í: 'I',
  Ó: 'O',
  Ú: 'U'
}

export function accentFold(s) {
  if (!s) {
    return ''
  }

  let ret = ''

  for (let i = 0; i < s.length; i++) {
    ret += accentMap[s.charAt(i)] || s.charAt(i)
  }

  return ret
}

export const formatCUIL = (cuil: string) =>
  `${cuil.substring(0, 2)}-${cuil.substring(
    2,
    cuil.length - 1
  )}-${cuil.substring(cuil.length - 1, cuil.length)}`

export const nonNumericalChars = ['e', 'E', '+', '-', '.', ',']

export const isAppleDevice = /iPhone|iPad|iPod|Mac/.test(navigator.userAgent)

// replaces line breaks with a space
export function removeLineBreaks(str: string) {
  return str.replace(/[\r\n]+/gm, ' ').trim()
}

// removes all special characters
export function removeSpecialCharacters(str: string) {
  return str.replace(/[^A-Za-z0-9\s]/g, '')
}

// removes special characters AND line breaks
export function cleanString(str: string) {
  return removeSpecialCharacters(removeLineBreaks(str))
}
